import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/api/auth";
import { AuthCard } from "@/components/auth/AuthCard";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mfaCode, setMfaCode] = useState("");
  const [needsMfa, setNeedsMfa] = useState(false);
  const [clientError, setClientError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setClientError(null);
    try {
      await login(email, password, mfaCode || undefined);
      navigate("/media-content/command-center", { replace: true });
    } catch (err) {
      const message = err instanceof Error ? err.message : "";
      if (message.toLowerCase().includes("mfa") || message.toLowerCase().includes("totp")) {
        setNeedsMfa(true);
      }
      setClientError(message);
    }
  };

  return (
    <AuthCard
      title="EVzone Media & Content Platform"
      subtitle="Sign in to your workspace"
      footer={
        <>
          <Link to="/auth/forgot-password">Forgot password?</Link>
          <br />
          
        </>
      }
    >
      <form onSubmit={handleSubmit} className="ev-login__form">
        <label className="ev-login__field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="email"
            data-testid="auth-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
        </label>
        <label className="ev-login__field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            data-testid="auth-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
            required
          />
        </label>
        {needsMfa && (
          <label className="ev-login__field">
            <span>MFA code</span>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value)}
              disabled={isLoading}
              placeholder=""
              required
            />
          </label>
        )}
        {(error || clientError) && (
          <div className="ev-login__error" role="alert">
            {clientError || error}
          </div>
        )}
        <button type="submit" className="ev-login__submit" data-testid="auth-submit" disabled={isLoading}>
          {isLoading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </AuthCard>
  );
}
